import { CommonServiceIds } from 'azure-devops-extension-api';
import { CoreRestClient } from 'azure-devops-extension-api/Core';
import { getExtensionContext, getService } from 'azure-devops-extension-sdk';
import { HostPlatform } from '../config/hostPlatform';

const isAzure = HostPlatform.isAzure();
const isJira = HostPlatform.isJira();

export async function getRetrospectiveUrl(retrospectiveId) {
  if (isAzure) {
    return await getAzureRetrospectiveUrl(retrospectiveId);
  }
  if (isJira) {
    return await getJiraRetrospectiveUrl(retrospectiveId);
  }

  throw new Error('Unsupported platform');
}
export const getAzureRetrospectiveUrl = async (retrospectiveId) => {
  const locationService = await getService(CommonServiceIds.LocationService);
  const projectPageService = await getService(
    CommonServiceIds.ProjectPageService
  );
  const hostBaseUrl = await locationService.getResourceAreaLocation(
    CoreRestClient.RESOURCE_AREA_ID
  );
  const projectInfo = await projectPageService.getProject();
  const projectName = encodeURI(projectInfo.name);
  const extensionId = getExtensionContext().id;

  const url = `${hostBaseUrl}${projectName}/_apps/hub/${extensionId}.retrospectives.index-hub#/retrospectives/`;

  if (!retrospectiveId) {
    return url;
  }

  return url + retrospectiveId;
};

export const getJiraRetrospectiveUrl = async (retrospectiveId) => {
  return new Promise((resolve) => {
    AP.getLocation((location) => {
      const url = new URL(location);
      const decodedSearchParameters = url.searchParams
        .toString()
        .replace('%3A', ':');
      const retrospectiveUrl = `${url.protocol}//${url.host}${url.pathname}?${decodedSearchParameters}#!/retrospectives/${retrospectiveId}`;
      resolve(retrospectiveUrl);
    });
  });
};
